import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import PropTypes from "prop-types";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const BlurryDialog = (props) => {

    return (

        <Dialog
            open={props.open}
            onClose={props.handleClose}
            fullWidth
            maxWidth={ props.maxWidth ? props.maxWidth : 'xs'}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            TransitionComponent={Transition}
            sx={{
                backdropFilter: "blur(5px)",
                //other styles here
            }}
        >
            {props.children}
        </Dialog>
    );
};

BlurryDialog.propTypes = {
    maxWidth: PropTypes.string
};

export default BlurryDialog;